module.exports = __webpack_public_path__ + "img/流体力学4_5.0572fdf6.jpg";